// extracted by mini-css-extract-plugin
export default {"infinitScrollContainer":"Events-module__infinitScrollContainer___c7PH7","createEventsContainer":"Events-module__createEventsContainer___XooR6"};